<template>
  <v-container fluid class="containerBig">
    <DialogSaveItem ref="dlgSave" @doItem="savePeegroup"></DialogSaveItem>
    <DialogSelectPeergroup ref="dlgSelectPeergroup" @doItem="loadPeergroup" @doReload="loadPGList"></DialogSelectPeergroup>
    <DialogChooseYear ref="dlgChooseYear" @doItem="optimizePeergroup"></DialogChooseYear>
    <v-dialog
      v-model='dialog'
      persistent
      class="pb-4"
      scrollable
    >
      <v-card>
        <v-card color="blue" v-if="doubleEntries">
          <v-card-title :key="alertIndex" flat class='white--text subheading'>{{ 'TITLE_DOUBLE_ENTRIES_DIALOG' | translate}} ({{doubleEntries.length}})
          </v-card-title>
        </v-card>
        <span v-if="warning">{{warnMessage}}</span>
        <v-card-text>
          <v-data-table
            :headers="headersDoubles"
            :items="doubleEntries"
            class="peerTable"
            hide-actions
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th class="">
                  {{ 'TEXT_ACTION' | translate}}
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="['column text-xs-left sortable ' + getHeaderClass(header), pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSortDouble(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <tr class="handpointer">
                <td>
                  <v-icon v-if="!props.item.isAnkerBank" color="red" @click="deleteItem(props.item)">clear</v-icon>
                  <!--<v-icon :title="props.item.alertText" :text="props.item.alertText" v-if="props.item.hasAlert" color="yellow">warning</v-icon>-->
                </td>
                <td class="text-xs-left" v-for="header in headersDoubles" :key="header.id">{{ getValue(props.item, header)}}
                </td>
              </tr>
            </template>
          </v-data-table>

        </v-card-text>
        <v-card-actions>
          <v-flex md3 class="pa-2">
            <v-select
              :items="removeAttributeList"
              v-model='removeModel'
              style="z-index:99999911111111"
              color="primary"
              :return-object="true"
              item-text="text"
              :label="PREFER_TITLE_ABSCHLUSS"
            ></v-select>
          </v-flex>
          <v-flex md3>
            <v-btn color="primary" flat small @click="preferAbschluss()">{{ 'BUTT_PREFER' | translate}}</v-btn>
          </v-flex>
          <v-flex md3 class="pa-2">
            <v-select
              style="z-index:99999911111111"
              :items="removeAttributeList2"
              v-model='removeModel2'
              color="primary"
              :return-object="true"
              item-text="text"
              item-value="id"
              :label="PREFER_TITLE_RECHTSKREIS"
            ></v-select>
          </v-flex>
          <v-flex md3>
            <v-btn color="primary" flat small @click="preferRechtskreis()">{{ 'BUTT_PREFER' | translate}}</v-btn>
          </v-flex>
          <v-flex md3>
            <v-alert
              :value="showAlert"
              color="info"
              icon="info"
              outline
            >
              {{deleted}} {{ 'TEXT_PREFERED_REMOVED' | translate}}
            </v-alert>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="primary"
            @click="resetDialog()"
          >
            {{ 'BUTT_CLOSE' | translate}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap justify-center class="">
      <v-flex xs12 sm12 md12 lg12>
        <v-card>
          <v-card-title :key="alertIndex" flat class='blue white--text subheading pa-1 pl-3' height="45px">
            <v-layout row justify-end>
              <v-flex class="justify-start text-xs-left pt-2" xs6 sm6 md4>
                {{ 'TITLE_YOUR_PEERGROUP' | translate}} <span v-if="pgresults">&nbsp;({{pgresults.length}})</span>
              </v-flex>
              <v-flex class="justify-start text-xs-left" xs6 sm6 md8>
                <v-layout>
                  <v-flex xs12 sm6>
                    <v-checkbox v-if="showAddAnkerBankIntoPeergroup"
                                v-model="addAnkerBankIntoPeergroup"
                                :label="SWITCH_ADD_ANKER_INTO_PG"
                                color="white"
                    dark
                    class="mt-0 pt-2">
                    </v-checkbox>
                    <!--<v-switch
                      dark
                      color="white"
                      class="mt-0 pt-2"
                      v-if="showAddAnkerBankIntoPeergroup"
                      v-model="addAnkerBankIntoPeergroup"
                      :label="SWITCH_ADD_ANKER_INTO_PG"
                    ></v-switch>-->
                  </v-flex>
                  <v-flex xs8 sm9 md10 class="justify-end text-xs-right">
                    <v-btn color="white" class="text-none" outline small
                           v-if="(overviewTableResult != null) && (overviewTableResult.length > 0)"
                           @click="showSavePeergroupDialog()">{{ 'BUTT_SAVE_PEERGROUP' | translate}}
                    </v-btn>
                    <v-btn color="white" class="text-none" outline small @click="showLoadPGDialog()">{{
                      'BUTT_LOAD_PEERGROUP'|
                      translate}}
                    </v-btn>
                    <v-btn color="white" v-if="userPGList != null" class="text-none" outline small
                           @click="showDialogChooseYear()">{{ 'BUTT_OPTIMIZE_PEERGROUP' | translate}}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- Funktionsfähiger Button, aktualisiert Peergoup sofort ohne Jahrauswahl
              <v-btn color="white" v-if="userPGList != null" class="text-none" outline small
                     @click="optimizePeergroup()">{{ 'BUTT_OPTIMIZE_PEERGROUP' | translate}}
              </v-btn> -->
            </v-layout>
          </v-card-title>
          <v-card-text style="overflow: hidden" class="pa-0 pt-1">
            <v-layout class="pa-0">
              <FixedTableIE :widthSub="0" :heightSub="198" :ankerBank="bankAnchor" ref="poTable"
                            :currency="currentCurrency"
                            :selected="selected"
                            @onItemDeleted="onItemDeleted"
                            :selectedFunc="selectedFunc"
                            v-if="(overviewTableResult != null) && (overviewTableResult.length > 0)"
                            :tableConfig='tableConfig'
                            :tableNotComplete="tableNotComplete"
                            :headers="headers" :items="overviewTableResult" class="colorrows"></FixedTableIE>
            </v-layout>
            <v-layout v-if="showOptSelection">
              <v-btn dark class="text-none blue" small @click="cancelOptimzedPeegroup()">
                {{'BUTT_OPTIMIZE_CANCEL'|translate}}
              </v-btn>
              <v-btn dark class="text-none blue" small @click="useOptimzedPeegroup()">
                {{'BUTT_OPTIMIZE_PG_TAKE'|translate}}
              </v-btn>
            </v-layout>
          </v-card-text>

          <v-card-actions class="pa-4" v-if="!showOptSelection">
            <v-btn color="#004884" class="text-none blue" outline small @click="openPeerGroupSearch()">{{BUTT_ADD}}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn dark class="text-none blue" v-if="(overviewTableResult.length > 1)" small @click="openPeerGroup()">
              {{'BUTT_START_PEERGROUP_ANALYSIS' |translate}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  // import swal from 'sweetalert2'
  import Vue from 'vue'
  import moment from 'moment'
  import FixedTableIE from './../tables/EasyTableIE'
  import DialogSaveItem from './../module/dialogs/DialogSaveItem'
  import DialogSelectPeergroup from './../module/dialogs/DialogSelectPeergroup'
  import DialogChooseYear from "./dialogs/DialogChooseYear";

  var $ = require('jquery')
  var _ = require('lodash')
  export default {
    components: {DialogChooseYear, FixedTableIE, DialogSaveItem, DialogSelectPeergroup},
    name: 'Peergroup',
    data() {
      return {
        loadedPGList: null,
        BUTT_ADD: Vue.i18n.translate('BUTT_ADD_BANK'),
        warning: false,
        overviewTableResult: [],
        doubleEntries: [],
        alertIndex: 1,
        warnMessage: '',
        dialog: false,
        isBlock: false,
        showAlert: false,
        ankerBank: null,
        showOptSelection: false,
        hasAnkerBank: false,
        target: '',
        deleted: 0,
        userPGList: [],
        headers: [],
        LABEL_PLZ_SELECT: Vue.i18n.translate('LABEL_PLZ_SELECT'),
        LABEL_PLZ_SELECT_PREFER: Vue.i18n.translate('LABEL_PLZ_SELECT_PREFER'),
        PREFER_TITLE_ABSCHLUSS: Vue.i18n.translate('PREFER_TITLE_ABSCHLUSS'),
        PREFER_TITLE_RECHTSKREIS: Vue.i18n.translate('PREFER_TITLE_RECHTSKREIS'),
        headersDoubles: [],
        crefoDoubleExists: false,
        pagination: {
          rowsPerPage: 5000,
          descending: true,
          sortBy: 'balanceSum'
        },
        addAnkerBankIntoPeergroup: false,
        showAddAnkerBankIntoPeergroup: false,
        removeModel: null,
        removeModel2: null,
        tt: {},
        removeAttributeList: [
          {
            text: Vue.i18n.translate('LABEL_PREFER_KONZERNAB'),
            id: '2'
          },
          {
            text: Vue.i18n.translate('LABEL_PREFER_EINZELAB'),
            id: '1'
          }
        ],
        removeAttributeList2: [
          {
            text: 'Bankbilanz IFRS 9',
            id: '45'
          },
          {
            text: 'Bankbilanz IAS 39',
            id: '89'
          },
          {
            text: 'Bankbilanz National-IAS 39',
            id: '90'
          },
          {
            text: 'Bankbilanz National-IFRS 9',
            id: '127'
          }
        ],
        numberRegex: /^\s*[+-]?(\d+|\.\d+|\d+\.\d+|\d+\.)(e[+-]?\d+)?\s*$/,
        paginationDouble: {
          rowsPerPage: 5000,
          descending: true,
          sortBy: 'balanceSum'
        },
        pgresults: [],
        tableNotComplete: false,
        tableData: [],
        currentCurrency: '1',
        currency: '1',
        bankAnchor: null,
        selected: [],
        searchData: {
          name: '',
          country: 'DE',
          hgbNr: '',
          industry: ''
        },
        optimizedYear: null,
        SWITCH_ADD_ANKER_INTO_PG: '',
        countries: [],
        'tableConfig': {
          selection: false,
          isClickable: false,
          actionButtons: {
            buttons: [
              {
                index: 0,
                icon: 'clear',
                color: '#E05469',
                type: 'remove',
                tooltipText: Vue.i18n.translate('TOOLTIP_DELETE')
              },
              {
                index: 1,
                icon: 'warning',
                color: '#8ACAC1',
                type: 'check',
                checkProperty: 'hasAlert'
              },
              {
                index: 2,
                icon: 'fiber_new',
                color: '#A763A4',
                xcolor: '#DDDF4A',
                type: 'check',
                checkProperty: 'isNew'
              }
            ]
          },
          header: {
            columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn'
          },
          rows: {
            rowClass: 'rowEIE'
          }
        }
      }
    },
    methods: {
      removeFromList(index) {
        this.deleted = 0
        this.removeItemsWith(this.removeModel)
      },
      computeDoubleEntries() {
        Vue.prototype.$api.debug('computeDoubleEntries', this.pgresults)
        var arr = []

        _.forEach(this.pgresults, function (data) {
          if (data.meta.isDuplette) {
            arr.push(data)
          }
        })
        this.doubleEntries = arr
        Vue.prototype.$api.debug('computeDoubleEntries done', this.doubleEntries)
      },
      preferAbschluss() {
        Vue.prototype.$api.debug('preferAbschluss', this.pgresults)
        var preferModel = this.removeModel
        this.deleted = 0
        var array = this.doubleEntries.filter(item => {
          return item.meta.isDuplette
        })
        var crefoNrMap = this.createCrefoMap(array)
        for (var index2 in crefoNrMap) {
          var crefoNr = crefoNrMap[index2]
          var arrSameCrefoNr = this.doubleEntries.filter(item => {
            return item.meta.isDuplette && (item.meta.balance.crefoNr + '' === crefoNr + '')
          })
          var onePreferredExists = false
          for (var ii2 in arrSameCrefoNr) {
            var item22 = arrSameCrefoNr[ii2]
            if (preferModel.id * 1 === item22.meta.balance.aaNr) {
              onePreferredExists = true
              break;
            }
          }
          if (onePreferredExists) {
            // Delete all other
            for (var ii3 in arrSameCrefoNr) {
              var item33 = arrSameCrefoNr[ii3]
              if (preferModel.id * 1 !== item33.meta.balance.aaNr) {
                this.deleted++
                this.deleteItem(item33, true)
              }
            }
          }
        }
        this.doubleEntries = this.doubleEntries.filter(item => {
          return !item.deleteMe
        })
        this.pgresults = this.pgresults.filter(item => {
          return !item.deleteMe
        })
        if (this.pgresults.length < 1) {
          this.dialog = false
          this.openTable()
        } else {
          this.doAlert()
          Vue.prototype.$api.debug('preferAbschluss done', this.pgresults.length)
        }
      },
      preferRechtskreis() {
        Vue.prototype.$api.debug('preferRechtskreis', this.removeModel2.id)
        Vue.prototype.$api.showIdle()
        var preferModel = this.removeModel2
        this.deleted = 0
        var array = this.doubleEntries.filter(item => {
          return item.meta.isDuplette
        })
        var crefoNrMap = this.createCrefoMap(array)

        for (var index2 in crefoNrMap) {
          var crefoNr = crefoNrMap[index2]
          var arrSameCrefoNr = this.doubleEntries.filter(item => {
            return item.meta.isDuplette && (item.meta.balance.crefoNr + '' === crefoNr + '')
          })

          var onePreferredExists = false
          for (var ii2 in arrSameCrefoNr) {
            var item22 = arrSameCrefoNr[ii2]
            if (preferModel.id * 1 === item22.meta.balance.rkNr * 1) {
              onePreferredExists = true
              break;
            }
          }
          if (onePreferredExists) {
            // Delete all other
            for (var ii3 in arrSameCrefoNr) {
              var item33 = arrSameCrefoNr[ii3]
              if (preferModel.id * 1 !== item33.meta.balance.rkNr * 1) {
                onePreferredExists = true
                // toDelete.push(item33)
                this.deleteItem(item33, true)
                this.deleted++
              }
            }
          }
        }
        this.doubleEntries = this.doubleEntries.filter(item => {
          return !item.deleteMe
        })
        this.pgresults = this.pgresults.filter(item => {
          return !item.deleteMe
        })
        this.doAlert()
        Vue.prototype.$api.debug('preferRechtskreis done', this.doubleEntries.length)
      },
      createCrefoMap(array) {
        var crefoNrMap = []
        for (var index3 in array) {
          var item3 = array[index3]
          crefoNrMap[item3.meta.balance.crefoNr] = item3.meta.balance.crefoNr
        }
        return crefoNrMap
      },
      selectedFunc(selectedItem, tableItems, ieTable) {
        for (var index in tableItems) {
          var item = tableItems[index]
          if (!Vue.prototype.$api.compareBalance(selectedItem.meta.balance, item.meta.balance)) {
            if (Vue.prototype.$api.compareBalanceWithoutYear(selectedItem.meta.balance, item.meta.balance)) {
              item.selected = false
              item.meta.value = 0
              ieTable.removeItem(item)
              // console.log('remove selection', item)
            }
          }
        }
      },
      submit() {
        // console.log('submit')
      },
      changeSortDouble(column) {
        Vue.prototype.$api.debug('change sort double', column)
        if (this.paginationDouble.sortBy === column) {
          this.paginationDouble.descending = !this.paginationDouble.descending
        } else {
          this.paginationDouble.sortBy = column
          this.paginationDouble.descending = false
        }
      },
      changeSort(column) {
        Vue.prototype.$api.debug('change sort', column)
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      getHeaderClass(header) {
        if (header.value === 'balanceSum') {
          return 'text-xs-right'
        }
        return 'text-xs-left'
      },
      getClassFor(header) {
        if (header.value === 'balanceSum') {
          return 'text-xs-right'
        }
        return 'text-xs-left'
      },
      isNumber(s) {
        if (!s) return false
        return this.numberRegex.test(s)
      },
      getHint(item, head) {
        if (item && head && item[head.value]) {
          return item[head.value].tt
        }
        return ''
      },
      getCO(item, head) {

        if (item[head.value]) {
          var value = item[head.value].co
          var type = head.meta.type
          var format = head.meta.format

          // var format = item[head.value].format

          if (item[head.value] && item[head.value].format) {
            format = item[head.value].format
          }
          if (item[head.value] && item[head.value].type) {
            type = item[head.value].type
          }

          if (!format) {
            format = ''
          }

          if ((type === 'comp-icon') || (type === 'comp-ref-icon') || (type === 'trendicon')) {
            var color = 'textcolor-green'
            var i = item[head.value].co
            if (i === '') return ''
            if (i === 0) return ''
            var arrow = ''
            if (i === -1) {
              arrow = 'arrow_drop_down'
              color = 'textcolor-red'
            }
            if (i === 1) arrow = 'arrow_drop_up'
            if (arrow !== '') {
              value = '<i aria-hidden="true" class="' + color + ' v-icon material-icons theme--light">' + arrow + '</i>'
            }
            return value
          }

          if (value || (value === 0)) {
            var valueBefore = value
            if ((format.toLowerCase() === '')) {
              return value
            }
            if ((format.toLowerCase() === 't')) {
              return value
            }
            if ((type === 'sp') && this.isNumber(value)) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
              var cur = Vue.prototype.$api.getI18NCurrency(this.currency).name
              value = value + ' ' + cur
            } else if ((type === 'raw') && this.isNumber(value)) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((type === 'kz') && this.isNumber(value)) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((format.toLowerCase() === 'f2t')) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((format.toLowerCase() === 'f0t')) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((format.toLowerCase() === 'f1t')) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            }

          }
          if (value === 'NaN') {
            Vue.prototype.$api.debug('valueBefore', valueBefore, value)
          }
          /*
          */
          var hint = this.getHint(item, head)
          var hasHint = hint != null && (hint.length > 0)
          if (hasHint) {
            if (this.tableConfig.hideHintStars) {

            } else {
              value = value + '<sup>*</sup>'
            }
          }
        }
        if (!value) value = ''
        if (value === 'undefined') value = ''
        /* if (item && item.meta.level) {
           for (var i = 0; i < item.meta.level; i++) {
             value = '&nbsp;&nbsp;' + value
           }
         }*/
        return value
      },
      getValue(item, _header) {
        return this.getCO(item, _header)
        var value = item[_header.value].co
        if (_header.value === 'rechtskreis') {
          var e = Vue.prototype.$api.getI18NRechtsKreis(item.rechtskreis)
          if (e) {
            return e.title
          }
        } else if (_header.value === 'country') {
          e = Vue.prototype.$api.getI18NCountry(item.country)
          if (e) {
            return e.title
          }
        } else if (_header.value === 'branch') {
          e = Vue.prototype.$api.getI18NBranche(item.branch)
          if (e) {
            return e.title
          }
        } else if (_header.value === 'abschlussart') {
          e = Vue.prototype.$api.getI18NAbschlussart(item.abschlussart)
          if (e) {
            return e.title
          }
        } else if (_header.value === 'balanceSum') {
          /* Overwrite value here with bSum */
          if (!this.isAnkerBank(item)) {
            value = item['balanceSumKurs']
          } else {
            value = this.ankerBank.balanceSum
          }

          if (!Number.isFinite(value)) {
            var maximumFractionDigits = 0
            var minimumFractionDigits = 0
            var vvv = (1 * value).toLocaleString('de-DE', {
              style: 'decimal',
              useGrouping: true,
              maximumFractionDigits: maximumFractionDigits,
              minimumFractionDigits: minimumFractionDigits
            })

            var cur = Vue.prototype.$api.getI18NCurrency(this.currency).name
            if (cur) {
              return vvv + ' ' + cur
            }
            return vvv
          }
        }
        if (value.length === 0) {
          return '-'
        }
        return value
        // return PGTable.getValueFromItem(item, headColumn)
      },
        /*var value = item[_header.value]
        if (_header.value === 'rechtskreis') {
          var e = Vue.prototype.$api.getI18NRechtsKreis(item.rechtskreis)
          if (e) value = e.title
        }
        if (_header.value === 'country') {
          e = Vue.prototype.$api.getI18NCountry(item.country)
          if (e) value = e.title
        }
        if (_header.value === 'branch') {
          e = Vue.prototype.$api.getI18NBranche(item.branch)
          if (e) value = e.title
        }
        if (_header.value === 'abschlussart') {
          e = Vue.prototype.$api.getI18NAbschlussart(item.abschlussart)
          if (e) value = e.title
        }
        if (_header.value === 'balanceSum') {

          if (!item.isAnkerBank) {
            value = item['balanceSumKurs']
          }
          if (!Number.isFinite(value)) {
            var maximumFractionDigits = 2
            var minimumFractionDigits = 2
            value = (1 * value).toLocaleString('de-DE', {
              style: 'decimal',
              useGrouping: true,
              maximumFractionDigits: maximumFractionDigits,
              minimumFractionDigits: minimumFractionDigits
            })
          }
        }
        if (item.isAnkerBank) {
          var v = value
          if (!v) v = ''
          return '<b>' + v + '</b>'
        }
        if (value && value.co) {
          return value.co
        }
        return value.co
      },
      */
      onGetHitListConfig(data) {
        this.headerFields = data.array
        /*

        this.headersDoubles.push({
          text: 'Crefo-Nr',
          value: 'crefoNr',
          sortable: true
        })
        for (var index in data) {
          var item = data[index]
          this.headers.push({
            text: Vue.prototype.$api.onGetI18NHitListValue(item.id),
            value: item.field,
            sortable: true
          })
          this.headersDoubles.push({
            text: Vue.prototype.$api.onGetI18NHitListValue(item.id),
            value: item.field,
            sortable: true
          })
        }
        */
      },
      showSavePeergroupDialog() {
        var balances = []
        for (var index in this.pgresults) {
          var item = this.pgresults[index]
          balances.push(item.meta.balance)
        }
        this.$refs.dlgSave.open()
      },
      optimizePeergroup(yearData) {
        this.optimizedYear = yearData
        Vue.prototype.$api.getBalanceDataWithBalanceStringArrayOptimized(yearData, this.loadedPGList, this.headerFields, this.onGetOptimized)
      },
      showLoadPGDialog() {
        this.$refs.dlgSelectPeergroup.open(this.userPGList)
      },
      showDialogChooseYear() {
        this.$refs.dlgChooseYear.open()
      },
      onGetPeergroupList(list) {
        Vue.prototype.$api.debug('onGetPeergroupList', list)
        this.userPGList = list
      },
      loadPeergroup(pgId) {
        Vue.prototype.$api.debug('loadPeergroup', pgId)
        Vue.prototype.storage.clearState('pgLastHitList_' + Vue.prototype.$api.getModuleId() + '_Peergroup')
        Vue.prototype.$api.loadPeergroupListById(pgId, this.onGetPeergroupLisById)
      },
      onGetPeergroupLisById(list) {
        Vue.prototype.$api.debug('onGetPeergroupLisById', list)
        this.loadedPGList = list.balanceArray
        Vue.prototype.storage.ankerBank = null
        Vue.prototype.storage.hasAnkerBank = false
        Vue.prototype.storage.peergroupData[Vue.prototype.$api.getModuleId()] = []
        Vue.prototype.storage.peergroupDataRows[Vue.prototype.$api.getModuleId()] = []

        Vue.prototype.storage.resetAnkerbank(Vue.prototype.$api.getModuleId())
        if (list.ankerBank) {
          this.hasAnkerBank = true
          Vue.prototype.storage.hasAnkerBank = true
          Vue.prototype.storage.ankerBank = Vue.prototype.$api.stringToBalance(list.ankerBank)
          this.ankerBank = Vue.prototype.storage.ankerBank
          Vue.prototype.storage.setAnkerbank(Vue.prototype.$api.getModuleId(), Vue.prototype.storage.ankerBank)
          Vue.prototype.storage.setAnkerbankData(Vue.prototype.$api.getModuleId(), {
            title: '',
            balance: Vue.prototype.storage.ankerBank
          })
        }
        this.headerFields = [ 2, 1, 3, 17, 16, 15, 14 ];
        Vue.prototype.$api.getBalanceDataWithBalanceStringArray(list.balanceArray, this.headerFields, this.onGetBalances2)
      },
      onGetBalances2(tableData) {
        Vue.prototype.$api.debug('onGetBalances2', tableData)
        var result = Vue.prototype.$api.prepareWaimeaTable(tableData.table)
        this.pgresults = result.rows

        let missingTitle = false
        if (this.ankerBank) {
          if (!Vue.prototype.storage.getAnkerbankData(Vue.prototype.$api.getModuleId()) || (Vue.prototype.storage.getAnkerbankData(Vue.prototype.$api.getModuleId()).title === '')) {
            missingTitle = true
          }
        }

        var pgData = []
        this.headers = [{
          "text": "Aktion",
          "meta": {
            "type": "action",
            "title": "Aktion",
            "width": "10",
            "align": "L",
            "format": "text"
          },
          "value": "-1",
          "format": 'action',
          "isExtraField": false,
          "columnClass": "col00",
          "index": -1,
          "id": -1,
          "isVisible": true,
          "sortable": true
        }]
        this.headersDoubles = result.headers
        this.headers = this.headers.concat(result.headers)
        this.computeOverviewTableResult()
        this.pgresults = this.checkDouble(this.pgresults)
        for (var i in this.pgresults) {
          var item = this.pgresults[i]
          if (this.hasAnkerBank) {
            if (Vue.prototype.$api.compareBalance(item.meta.balance, Vue.prototype.storage.ankerBank)) {
              item.meta.balance.isAnkerBank = true
              if (missingTitle) {
                Vue.prototype.storage.setAnkerbankData(Vue.prototype.$api.getModuleId(), {
                  title: item[1].co,
                  balance: Vue.prototype.storage.ankerBank
                })
              }
            }
          }
          pgData.push(item.meta.balance)
        }

        Vue.prototype.storage.setPeergroup(Vue.prototype.$api.getModuleId(), pgData)
        this.showAddAnkerBankIntoPeergroup = Vue.prototype.storage.hasAnkerBank
        window.setTimeout(this.openTable, 100)
        this.loadPGList()

      },
      savePeegroup(maskData) {
        var balances = []
        for (var index in this.pgresults) {
          var item = this.pgresults[index]
          balances.push(Vue.prototype.$api.balanceToString(item.meta.balance))
        }
        var pg = {
          name: maskData.name,
          balances: balances
        }
        if (this.hasAnkerBank) {
          pg.company = Vue.prototype.$api.balanceToString(this.ankerBank)
        }
        Vue.prototype.$api.savePeergroup(pg, this.loadPGList)
        Vue.prototype.$api.debug('savePeegroup',)
      },
      openPeerGroupSearch() {
        this.updateGroupFromTableData()
        var cmp = this
        var param = {
          idModule: cmp.idModule
        }
        this.$router.push({name: 'Peergroup', params: param})
      },
      openPeerGroup() {
        Vue.prototype.$api.debug('open peer group', this.crefoDoubleExists)
        if (this.crefoDoubleExists) {
          this.dialog = true
          this.computeDoubleEntries()
          return
        }
        /*
        var param = {}
        if (Vue.prototype.storage.hasAnkerBank) {
          param = {
            year: '' + Vue.prototype.storage.ankerBank.year,
            crefoNr: Vue.prototype.storage.ankerBank.crefoNr,
            rechtskreis: Vue.prototype.storage.ankerBank.rechtskreis,
            guid: Vue.prototype.storage.ankerBank.guid,
            hasAnkerbank: true,
            name: 'Peergroup'
          }
        } else {
          var bank = Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId())[0]
          param = {
            year: '' + bank.year,
            crefoNr: bank.guid,
            rechtskreis: bank.rechtskreis,
            guid: bank.guid,
            hasAnkerbank: false,
            name: 'Peergroup',
            isAnalyse: true
          }
        }
         */

        var bArray = []
        var balance = this.pgresults[0].meta.balance

        let ankerBankAlreadyExists = false
        let isAnkerBank = Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())
        for (var i in this.pgresults) {
          var item = this.pgresults[i]
          bArray.push(item.meta.balance)
          if (!ankerBankAlreadyExists && isAnkerBank) {
            let same = Vue.prototype.$api.balanceToString(item.meta.balance) === Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId())
            if (same) {
              ankerBankAlreadyExists = true
            }
          }
        }

        if (this.addAnkerBankIntoPeergroup && !ankerBankAlreadyExists) { //  && !Vue.prototype.storage.alreadyAddAnkerBankIntoPeergroup
          Vue.prototype.storage.alreadyAddAnkerBankIntoPeergroup = true
          bArray.push(Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()))
        }
        console.log('bArray', bArray, isAnkerBank)

        Vue.prototype.storage.setPeergroup(Vue.prototype.$api.getModuleId(), bArray)


        this.$router.push(Vue.prototype.$api.getStructureUrl(Vue.prototype.$api.getModuleId(), balance))
        // this.$router.push(Vue.prototype.$api.getStructureUrlOfArray(Vue.prototype.$api.getModuleId(), bArray))

        // Vue.prototype.$api.debug(param, Vue.prototype.storage.groupData)
        // this.$router.push({name: 'AnkerbankDetails', params: param})
      },
      clear() {
        this.searchData.name = ''
        this.searchData.country = 'GB'
        this.searchData.hgbNr = ''
        this.searchData.industry = ''
      },
      removeItemsWith(name) {
        var array = this.tableData.filter(item => {
          return item.isDuplette
        })

        for (var index2 in array) {
          var item2 = array[index2]
          var delMe = false
          if (name === 'Konzernabschluss') {
            if (item2.abschlussart === '2') {
              delMe = true
            }
          }
          if (name === 'Einzelabschluss') {
            if (item2.abschlussart === '1') {
              delMe = true
            }
          }
          if (name === 'IRFS') {
            if (item2.rechtskreis === '45') {
              delMe = true
            }
          }
          if (name === 'IRFSAlt') {
            if (item2.rechtskreis === '89') {
              delMe = true
            }
          }
          if (delMe) {
            this.deleted++
            this.deleteItem(item2)
          }
        }
        this.doAlert()
      },
      /*
      prepareTable () {
        this.pgresults = []
        Vue.prototype.$api.debug('prepareTable', this.tableData)
        for (var index2 in this.tableData) {
          var item2 = this.tableData[index2]
          this.pgresults.push(item2.cells)
        }
        this.headers = [{
          "text": "Aktion",
          "meta": {
            "type": "action",
            "title": "Aktion",
            "width": "8",
            "align": "L",
            "format": "text"
          },
          "value": "-1",
          "format": 'action',
          "isExtraField": false,
          "columnClass": "col00",
          "index": -1,
          "id": -1,
          "isVisible": true,
          "sortable": true
        }]
        this.headers = this.headers.concat(Vue.prototype.storage.getStorage('pgoverviewHeader'))
        this.headersDoubles = this.headers

        window.setTimeout(this.openTable, 100)
      },
      */
      openTable() {
        Vue.prototype.$api.debug('openTable', this.$refs.poTable)
        // console.log('openTable', new Date().getTime())
        if (this.$refs.poTable && this.$refs.poTable.updateData) {
          this.$refs.poTable.updateData(this.pgresults)
        } else {
          Vue.prototype.$api.debug('openTable restart try')
        }
        Vue.prototype.$api.debug('openTable done')
        // console.log('openTable done', new Date().getTime())
        Vue.prototype.$api.hideIdle()
      },
      doAlert() {
        this.showAlert = true
        Vue.prototype.$api.hideIdle()
        var cmp = this

        window.setTimeout(function () {
          cmp.showAlert = false
        }, 5000)

        this.pgresults = this.checkDouble(this.pgresults)
        this.computeDoubleEntries()

        if (this.doubleEntries.length < 1) {
          this.dialog = false
          Vue.prototype.$api.showIdle()
          window.setTimeout(function () {
            cmp.openTable()
            Vue.prototype.$api.hideIdle()
          }, 100)
        } else {
          this.computeOverviewTableResult()
          cmp.alertIndex = cmp.alertIndex + 1
        }
      },
      deleteItem(itemToDelete, forceUncheck) {
        var index = this.pgresults.indexOf(itemToDelete)
        if (index > -1) {
          this.pgresults[index].deleteMe = true
          if (!forceUncheck) this.pgresults.splice(index, 1)
        }
        index = this.doubleEntries.indexOf(itemToDelete)
        if (index > -1) {
          this.doubleEntries[index].deleteMe = true
          if (!forceUncheck) this.doubleEntries.splice(index, 1)
        }
        if (!forceUncheck) {
          this.pgresults = this.checkDouble(this.pgresults)
          this.computeDoubleEntries()
          this.updatePeergroupFromPGResult()
          if (this.doubleEntries.length < 1) {
            this.dialog = false
            this.openTable()
          }
        }
      },
      onItemDeleted(data) {
        var button = data.button
        var item = data.item
        this.pgresults = data.items
        this.updatePeergroupFromPGResult()
      },
      checkAnkerItemAlreadyInList(array, ankerItem) {
        var exists = false
        for (var index2 in array) {
          var item2 = array[index2]
          if (item2.guid === ankerItem.guid) {
            exists = true
            item2.isAnkerBank = true
          }
        }
        return exists
      },
      monthDiff(d1, d2) {
        var months
        var y1 = d1.getFullYear()
        var y2 = d2.getFullYear()
        months = (y1 - y2) * 12
        // months -= d1.getMonth() + 1
        // months += d2.getMonth()
        if (months < 0) {
          months = months * -1
        }
        return months <= 0 ? 0 : months
      },
      getTimeOfBilanz(dateString) {
        if (dateString === null) return 0
        if (!dateString) return 0
        var mydate = moment(dateString, "YYYY-MM-DD")
        return mydate.toDate().getTime()
      },
      updateGroupFromTableData() {
        var allData = []
        if (this.$refs.poTable) {
          allData = this.$refs.poTable.getAll()
        }

        Vue.prototype.storage.groupData = []
        for (var index in allData) {
          var item = allData[index]
          Vue.prototype.storage.groupData.push(item.meta.balance)
        }
      },
      /*
          updateGroupFromTableData () {
            Vue.prototype.storage.groupData = []
            var allData = []
            if (this.$refs.poTable) {
              this.$refs.poTable.getAll()
              for (var index in allData) {
                var item = allData[index]
                Vue.prototype.storage.groupData.push(item.meta.balance)
              }
            }
          },
      */
      getAnkerItem() {
        if (!this.hasAnkerBank) return {}
        if (!this.ankerBank) return {}
        return {
          timeOfBilanz: this.getTimeOfBilanz(this.ankerBank.balanceDate),
          branch: this.ankerBank.branch,
          balanceSum: this.ankerBank.balanceSum,
          country: this.ankerBank.country,
          crefoNr: this.ankerBank.crefoNr,
          guid: this.ankerBank.guid,
          hgpNr: this.ankerBank.hgpNr,
          name: this.ankerBank.name,
          rechtskreis: this.ankerBank.rechtskreis,
          region: this.ankerBank.region,
          turnover: this.ankerBank.turnover,
          year: '' + this.ankerBank.year,
          abschlussart: this.ankerBank.abschlussart,
          selected: true,
          isAnkerBank: true,
          selectedInSession: true
        }
      },
      resetDialog() {
        this.dialog = false
        this.computeOverviewTableResult()
        this.openTable()
      },
      checkDouble(data) {
        Vue.prototype.$api.debug('checkDouble', data, data.length)
        this.crefoDoubleExists = false
        var crefoNummerDouble = []
        var cmp = this
        _.forEach(data, function (data) {
          var item = data.meta
          item.hasAlert = false
          item.isDuplette = false
          item.alertText = null
          var time = cmp.getTimeOfBilanz(item.balance.balanceDate)
          var diffMonth = cmp.monthDiff(new Date(time), new Date())
          if (diffMonth > 25) {
            item.hasAlert = true
            item.alertText = 'Keine Bilanz verfügbar oder älter als 26 Monate'
          }
          if (crefoNummerDouble[item.balance.crefoNr]) {
            crefoNummerDouble[item.balance.crefoNr].items.push(data)
          } else {
            crefoNummerDouble[item.balance.crefoNr] = {
              items: [data]
            }
          }
        })

        for (let [key, value] of Object.entries(crefoNummerDouble)) {
          var item = value
          if (item.items.length > 1) {
            cmp.crefoDoubleExists = true
            _.forEach(item.items, function (data) {
              var item = data.meta
              item.hasAlert = true
              item.alertText = 'Crefo Nummer doppelt.'
              item.isDuplette = true
            })
          }
        }
        /*
        _.forOwn(crefoNummerDouble, function (value, key) {
          var item = value
          console.log('crefoNummerDouble item ', item)
          if (item.items.length > 1) {
            cmp.crefoDoubleExists = true
            _.forEach(item.items, function (data) {
              var item = data.meta
              item.hasAlert = true
              item.alertText = 'Crefo Nummer doppelt.'
              item.isDuplette = true
            })
          }
        })
        */
        /*
        _.forEach(data, function (itemData) {
          var item = itemData.meta
          if (crefoNummerDouble[item.balance.crefoNr].items.length > 1) {
            cmp.crefoDoubleExists = true
            _.forEach(crefoNummerDouble[item.balance.crefoNr].items, function (data) {
              var item = data.meta
              item.hasAlert = true
              item.alertText = 'Crefo Nummer doppelt.'
              item.isDuplette = true
            })
          }
        })*/
        return data
      },
      loadPGList() {
        console.log('loadPGList')
        Vue.prototype.$api.getPeergroupList(this.onGetPeergroupList)
      },
      onGetOptimized(tableData) {
        Vue.prototype.$api.debug('onGetOptimized', tableData)
        this.tableConfig.selection = true
        this.tableConfig.actionButtons = {
          buttons: [
            {
              index: 1,
              icon: 'warning',
              color: '#8ACAC1',
              type: 'check',
              checkProperty: 'hasAlert'
            },
            {
              index: 2,
              icon: 'fiber_new',
              color: '#A763A4',
              xcolor: '#DDDF4A',
              type: 'check',
              checkProperty: 'isNew'
            }
          ]
        }
        this.showOptSelection = true
        var resultBefore = Vue.prototype.$api.prepareWaimeaTable(tableData.tables[0])
        var resultOptimized = Vue.prototype.$api.prepareWaimeaTable(tableData.tables[1])
        var balancesWithInfo = tableData.balances
        this.pgresults = resultBefore.rows
        // this.headers = result.headers
        this.headers = [{
          "text": "Aktion",
          "meta": {
            "type": "action",
            "title": "Aktion",
            "width": "10",
            "align": "L",
            "format": "text"
          },
          "value": "-1",
          "format": 'action',
          "isExtraField": false,
          "columnClass": "col00",
          "index": -1,
          "id": -1,
          "isVisible": true,
          "sortable": true
        }]
        this.headers = this.headers.concat(resultBefore.headers)
        this.headersDoubles = this.headers

        this.checkDouble(this.pgresults)


        this.loadedPGList = []
        var newRows = []
        for (var i in this.pgresults) {
          var item = this.pgresults[i]
          if (this.hasAnkerBank) {
            if (Vue.prototype.$api.compareBalanceWithoutYear(item.meta.balance, Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()))) {
              item.meta.balance.isAnkerBank = true
              item.isAnkerBank = true
            }
          }
          newRows.push(item)
          this.loadedPGList.push(Vue.prototype.$api.balanceToString(item.meta.balance))
          var isLast = false
          var lastItem = null
          this.selected = []
          this.itemYear = -1
          lastItem = item
          for (var oi in resultOptimized.rows) {
            var optimizedItem = resultOptimized.rows[oi]
            if (Vue.prototype.$api.compareBalance(optimizedItem.meta.balance, item.meta.balance)) {
              continue
            }
            // if (Vue.prototype.$api.compareBalanceWithoutYearAndRK(optimizedItem.meta.balance, item.meta.balance)) {
            if (optimizedItem.meta.balance.crefoNr === item.meta.balance.crefoNr) {
              this.selected.push(optimizedItem)


              var index = _.findIndex(balancesWithInfo, function (o) {
                var a = Vue.prototype.$api.balanceToString(optimizedItem.meta.balance)
                var b = Vue.prototype.$api.balanceToString(o)
                return a === b
              })
              //  && o.attr === 'added'
              optimizedItem.selected = false
              optimizedItem.meta.value = 0
              try {
                if (index > -1) {
                  optimizedItem.selected = balancesWithInfo[index].selected
                  if (balancesWithInfo[index].selected) {
                    optimizedItem.meta.value = 1
                  }
                }
              } catch (error) {

              }
              optimizedItem.meta.isNew = true
              optimizedItem.meta.radioItem = optimizedItem.meta.balance.crefoNr
              newRows.push(optimizedItem)
              lastItem = optimizedItem

              if (this.hasAnkerBank) {
                if (optimizedItem.meta.value === 1) {
                  if (Vue.prototype.$api.compareBalanceWithoutYearAndRK(item.meta.balance, Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()))) {
                    optimizedItem.selected = true
                    optimizedItem.meta.value = 1
                  }
                }
              }

              if (this.optimizedYear != null) {
                if (optimizedItem.meta.balance.year + '' === this.optimizedYear.year + '') {
                  this.itemYear = optimizedItem.meta.balance.year + ''
                }
              }
            }
          }
          if (lastItem) {
            lastItem.meta.type = 'lastItem'
            if (this.optimizedYear.year !== 0) {

              if (this.itemYear + '' !== this.optimizedYear.year + '') {
                item[0].co = item[0].co + ' <br><span class="pgRed"> ' + Vue.i18n.translate('MISSING_ANNUAL') + ' ' + this.optimizedYear.year + '</span>'
                // newRows.push(missingItem)
              }
            }
          }
        }
        this.pgresults = newRows
        // console.log('newRows', newRows)
        window.setTimeout(this.openTable, 100)

      },
      resetActionButtons () {
        this.tableConfig.actionButtons = {
          buttons: [
            {
              index: 0,
              icon: 'clear',
              color: '#E05469',
              type: 'remove',
              tooltipText: Vue.i18n.translate('TOOLTIP_DELETE')
            },
            {
              index: 1,
              icon: 'warning',
              color: '#8ACAC1',
              type: 'check',
              checkProperty: 'hasAlert'
            },
            {
              index: 2,
              icon: 'fiber_new',
              color: '#A763A4',
              xcolor: '#DDDF4A',
              type: 'check',
              checkProperty: 'isNew'
            }
          ]
        }
      },
      cancelOptimzedPeegroup() {
        this.showOptSelection = false
        this.tableConfig.selection = false
        this.resetActionButtons()
        var cmp = this
        Vue.prototype.$api.getBalanceData(Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId()), cmp.headerFields, cmp.onGetBalances)
      },
      useOptimzedPeegroup() {
        this.resetActionButtons()
        var deleteArr = []
        if (this.$refs.poTable) {
          var selection = this.$refs.poTable.getSelected()
          for (var index2 in this.pgresults) {
            var item2 = this.pgresults[index2]
            var found = false
            for (var index in selection) {
              var item = selection[index]

              console.log('compareBalance', item.meta.balance, item2.meta.balance)
              if (Vue.prototype.$api.compareBalance(item.meta.balance, item2.meta.balance)) {
                console.log(['compareBalance', item.meta.balance, item2.meta.balance, true, Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId())])
                if (this.hasAnkerBank) {
                  if (Vue.prototype.$api.compareBalanceWithoutYearAndRK(item.meta.balance, Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()))) {
                    console.log('setAnkerbank', item.meta.balance)
                    Vue.prototype.storage.setAnkerbank(Vue.prototype.$api.getModuleId(), item.meta.balance)
                    item2.meta.balance.year = item.meta.balance.year + ''
                    item2.meta.balance.isAnkerBank = true
                    item2.isAnkerBank = true
                  }
                }
                found = true
                break
              }

            }
            if (!found) {
              deleteArr.push(item2)
            }
          }
          for (var index2 in deleteArr) {
            var item2 = deleteArr[index2]
            var index = this.pgresults.indexOf(item2)
            if (index > -1) {
              this.pgresults.splice(index, 1)
            }
          }

          this.updatePeergroupFromPGResult()
        }
        this.showOptSelection = false
        this.tableConfig.selection = false
        var cmp = this
        if (this.hasAnkerBank) {
          console.log(['Ankerbank is now ', Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId())])
        }
        Vue.prototype.$api.getBalanceData(Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId()), cmp.headerFields, cmp.onGetBalances)
      },
      updatePeergroupFromPGResult() {
        console.log('updatePeergroupFromPGResult', this.pgresults)
        var pgData = []
        this.loadedPGList = []
        for (var index2 in this.pgresults) {
          var item2 = this.pgresults[index2]
          pgData.push(item2.meta.balance)
          this.loadedPGList.push(Vue.prototype.$api.balanceToString(item2.meta.balance))
        }
        this.pgresults = this.checkDouble(this.pgresults)
        Vue.prototype.storage.setPeergroup(Vue.prototype.$api.getModuleId(), pgData)
      },
      computeOverviewTableResult() {
        this.overviewTableResult = _.clone(this.pgresults, true)
      },
      loadFromStorage(balanceArr) {
        Vue.prototype.$api.debug('loadFromStorage', balanceArr)
        var tableData = {
          rows: [],
          headers: Vue.prototype.storage.currentHeader
        }

        let cntAnkerBanks = 0

        for (var index in balanceArr) {
          var balance = balanceArr[index]
          var row = Vue.prototype.storage.getPeergroupDataRowOfBalance(balance)
          if (!row) return false
          if (Vue.prototype.$api.compareBalance(Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()), balance)) {
            if (cntAnkerBanks > 0) continue
            cntAnkerBanks++;
          }
          tableData.rows.push(row)
        }
        Vue.prototype.$api.debug('loadFromStorage done')
        this.onGetBalances(tableData, true)
        return true
      },
      onGetBalances(tableData, isPrepared) {
        Vue.prototype.$api.debug('onGetBalances', tableData)
        var result = null
        if (!isPrepared) {
          result = Vue.prototype.$api.prepareWaimeaTable(tableData.table)
        } else {
          result = tableData
        }
        this.pgresults = result.rows
        let missingTitle = false
        if (this.hasAnkerBank) {
          if (Vue.prototype.storage.getAnkerbankData(Vue.prototype.$api.getModuleId()).title === '') {
            missingTitle = true
          }
        }
        this.computeOverviewTableResult()
        // this.headers = result.headers
        this.headers = [{
          "text": "Aktion",
          "meta": {
            "type": "action",
            "title": "Aktion",
            "width": "10",
            "align": "L",
            "format": "text"
          },
          "value": "-1",
          "format": 'action',
          "isExtraField": false,
          "columnClass": "col00",
          "index": -1,
          "id": -1,
          "isVisible": true,
          "sortable": true
        }]
        this.headersDoubles = result.headers
        this.headers = this.headers.concat(result.headers)
        this.pgresults = this.checkDouble(this.pgresults)
        this.loadedPGList = []
        for (var i in this.pgresults) {
          var item = this.pgresults[i]
          if (this.hasAnkerBank) {
            if (Vue.prototype.$api.compareBalanceWithoutYear(item.meta.balance, Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()))) {
              item.meta.balance.isAnkerBank = true
              item.isAnkerBank = true
              if (missingTitle) {
                Vue.prototype.storage.setAnkerbankData(Vue.prototype.$api.getModuleId(), {
                  title: item[1].co,
                  balance: Vue.prototype.storage.ankerBank
                })
              }
            }
          }
          this.loadedPGList.push(Vue.prototype.$api.balanceToString(item.meta.balance))
        }
        // console.log('5', new Date().getTime())
        Vue.prototype.$api.debug('onGetBalances done')
        this.showAddAnkerBankIntoPeergroup = Vue.prototype.storage.hasAnkerBank
        window.setTimeout(this.openTable, 100)
        this.loadPGList()
      }
    },
    mounted() {
      var cmp = this
      this.addAnkerBankIntoPeergroup = Vue.prototype.storage.alreadyAddAnkerBankIntoPeergroup
      this.SWITCH_ADD_ANKER_INTO_PG = Vue.i18n.translate('SWITCH_ADD_ANKER_INTO_PG_' + Vue.prototype.$api.getModuleId().toUpperCase())
      Vue.prototype.$api.showIdle(Vue.i18n.translate('IDLE_MESSAGE_BIG_DATA'))
      Vue.prototype.$api.checkCredentials(cmp, function () {
          Vue.prototype.$api.debug('Module Peergroup', Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId()))
          if (cmp.$route.params) {
            cmp.idModule = cmp.$route.params.idModule
            cmp.idModuleItem = cmp.$route.params.idModuleItem
          }
          // Vue.prototype.$api.getBreadCrumpModule(cmp.idModule)

          Vue.prototype.$api.getBreadCrumpModule(Vue.prototype.$api.getModuleId(), {
            id: 'Peegroup',
            text: 'Peergroup Suche',
            disabled: false,
            href: '/#/di/peergroup/companies'
          })

          cmp.link = '/di/StructureData/' + Vue.prototype.$api.getModuleId()

          cmp.hasAnkerBank = Vue.prototype.storage.hasAnkerBank
          cmp.ankerBank = Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId())
          cmp.target = Vue.prototype.$api.getModuleId() + '_' + cmp.idModuleItem
          Vue.prototype.$api.debug('target', cmp.target)

          cmp.headerFields = Vue.prototype.storage.currentHeaderFields
          cmp.currentCurrency = Vue.prototype.storage.getCurrency()
          cmp.currency = Vue.prototype.storage.getCurrency()
          // cmp.removeAttributeList2 = Vue.prototype.storage.getRechtskreise()
          if (Vue.prototype.$api.getModuleId() === 'companies') {
            cmp.removeAttributeList2 = [
              {
                text: 'HGB',
                id: '1'
              },
              {
                text: 'IFRS',
                id: '2'
              },
              {
                text: 'US-GAAP',
                id: '19'
              },
              {
                text: 'Sonstige',
                id: '15'
              }
            ]
          }

          if (!cmp.loadFromStorage(Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId()))) {
            Vue.prototype.$api.getBalanceData(Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId()), cmp.headerFields, cmp.onGetBalances)
          }

          // Vue.prototype.$api.getBalanceData(Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId()), cmp.headerFields, cmp.onGetBalances)

          cmp.BUTT_ADD = Vue.i18n.translate('BUTT_ADD_BANK_' + Vue.prototype.$api.getModuleId().toUpperCase())
          /*
          cmp.tableData = Vue.prototype.storage.groupData
          Vue.prototype.$api.debug('cmp.tableData', cmp.tableData)

          cmp.prepareTable()
          $('body').removeClass('noFlow')
           */
        }
      )
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/module/PeergroupOverview.vue